import { notifications } from "@mantine/notifications";
import { PropsWithChildren } from "react";
import { rankingContext, RankType } from "../contexts/ranking";
import { useRank } from "../hooks/useRank";

export const RankingProvider = ({ children }: PropsWithChildren) => {
  const first = useRank();
  const second = useRank();
  const third = useRank();

  const changeRanking = (rank: 1 | 2 | 3, id: number, type?: RankType) => {
    let modifier;
    switch (rank) {
      case 1:
        modifier = first;
        break;
      case 2:
        modifier = second;
        break;
      case 3:
        modifier = third;
        break;
    }

    if (id > 0 && !type) {
      throw new Error("A rank type is required with a id higher than 0");
    }

    if ([first, second, third].some((r) => r.data?.id === id && r.type === type)) {
      notifications.show({
        message: "Dit team/functie is al geselecteerd",
        variant: "warning"
      });
      return;
    }

    modifier.setInfo(id > 0 ? { type: type!, id } : null);
  };

  return (
    <rankingContext.Provider
      value={{
        first: first.returnData(),
        second: second.returnData(),
        third: third.returnData(),
        setRank: changeRanking
      }}
    >
      {children}
    </rankingContext.Provider>
  );
};
